import {
  DateTimeRange,
  TimeStampDateTimeRange,
} from '@modules/common/components/DateRangePicker/types';

export const replaceDateObjectWithTimeStamp = (
  date: DateTimeRange,
): TimeStampDateTimeRange => {
  if (!date) {
    return date;
  }

  switch (date.type) {
    case 'absolute':
      return {
        ...date,
        startAfter: date.startAfter?.valueOf(),
        endBefore: date.endBefore?.valueOf(),
      };
    case 'since':
      return {
        ...date,
        startAfter: date.startAfter?.valueOf(),
      };
    default:
      return date;
  }
};
